// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__SZUsm","tableExams":"styles_tableExams__DI0ab","tableExams_thead":"styles_tableExams_thead__xwuvP","tableExams_tbody":"styles_tableExams_tbody__oAcBG"};